import * as React from "react";
import { useState } from "react";
import { Checkbox } from "../../Elements/Checkbox";

export const UserConsentCheck = ({
    onChange,
    defaultChecked
}: {
    onChange: CallableFunction;
    defaultChecked?: boolean;
}): JSX.Element => {
    const [checked, setChecked] = useState<boolean>(defaultChecked || false);

    const onCheck = (val: boolean) => {
        setChecked(val);
        onChange(val);
    };

    return (
        <Checkbox
            label={"Apliecinu, ka esmu gatavs noslēgt nomas līgumu par publikācijā norādīto sākuma nomas maksu"}
            checked={checked}
            onChange={(val) => onCheck(val)}
        ></Checkbox>
    );
};
